import { SmsTemplate } from "@rumble-it/common-lib/types/models/SmsTemplate.interface";
import { UseMutationResult } from "@tanstack/react-query";
import { Button, Card, Input, Select } from "@rumbledirect/ui";
import { Form } from "antd";

interface SmsTemplateFormCardProps {
  mutation: UseMutationResult<null, Error, SmsTemplate, unknown>;
  loading?: boolean;
  initialValues?: SmsTemplate;
  title?: string;
  buttonText?: string;
}

export const SmsTemplateFormCard = ({
  mutation,
  loading,
  initialValues,
  title = "SMS Template Aanmaken",
  buttonText = "Aanmaken",
}: SmsTemplateFormCardProps) => {
  return (
    <Card loading={loading} title={title}>
      <Form
        onFinish={mutation.mutate}
        layout="vertical"
        initialValues={initialValues}
      >
        <Form.Item
          rules={[{ required: true, message: "Dit veld is verplicht." }]}
          label="Titel"
          name="title"
        >
          <Input />
        </Form.Item>
        <Form.Item
          rules={[
            { required: true, message: "Dit veld is verplicht." },
            {
              max: 160,
              message:
                "De inhoud van de SMS mag maximaal 160 karakters bevatten.",
            },
          ]}
          label="Inhoud"
          name="contents"
        >
          <Input.TextArea />
        </Form.Item>
        <Form.Item initialValue={"nl"} label="Taal" name="language">
          <Select
            options={[{ label: "Nederlands", value: "nl" }]}
            disabled={true}
          />
        </Form.Item>
        <Form.Item label={null}>
          <Button loading={mutation.isPending} type="primary" htmlType="submit">
            {buttonText}
          </Button>
        </Form.Item>
      </Form>
    </Card>
  );
};
